import cf from './cf';
import c41v from './c41v_20211024';

export default class c41v1a extends c41v { // 機能情報

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
//    this.class = this.constructor.name;
    this.class = 'c41v1a';
    this.d_viewDefs = {
      name: '役割'
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
